// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kOm-","footer":"styles_footer__2j4wJ"};